import { render } from "./DetailedAuctionItem.vue?vue&type=template&id=31eb0e44&scoped=true&ts=true"
import script from "./DetailedAuctionItem.vue?vue&type=script&lang=ts"
export * from "./DetailedAuctionItem.vue?vue&type=script&lang=ts"

import "./DetailedAuctionItem.vue?vue&type=style&index=0&id=31eb0e44&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31eb0e44"]])

export default __exports__